module.exports = __webpack_public_path__ + "img/croakfundingpartners-white-text-only-powered.f9393f3a.png";